import React from 'react'
import ImageHeader from '../../components/ImageHeader'
import headerImage from '../../assets/img/banners/Explore_Plan_Cover.jpg'
import '../../assets/css/pages/Expeditions/expeditions.css'
import '../../assets/css/sharedStyles.css'
import LoadingGif from '../../assets/img/loading-pinwheel.gif'
import { runQuery } from '../../fetchUtils'
import _ from 'lodash'
import ExpeditionsAssignmentModal from './ExpeditionsAssignmentModal'

const Expeditions = () => {
	const [expeditions, setExpeditions] = React.useState([])
	const [showAssignModal, setShowAssignModal] = React.useState({ show: false })
	const [isLoading, setIsLoading] = React.useState(false)

	React.useEffect(() => {
		const handlefetchExpeditions = () => {
			setIsLoading(true)
			const fetchExpeditionsQuery = `
			  query ExpeditionsQuery{
			    expeditions
			  }
			`

			const fetchExpeditionsCallback = {
				onComplete: json => {
					let error = json.data.expeditions[0]?.errors
					if (!_.isEmpty(error)) {
						console.error(error)
					} else {
						setExpeditions(json.data.expeditions)
					}
					setIsLoading(false)
				},
				onFailure: error => {
					console.error(error)
					setIsLoading(false)
				}
			}

			const vars = {}
			runQuery(fetchExpeditionsQuery, vars, fetchExpeditionsCallback)
		}

		handlefetchExpeditions()
	}, [])

	const handleClose = () => {
		setShowAssignModal({ show: false })
	}

	return (
		<ImageHeader image={headerImage} titleContents='Expeditions'>
			{isLoading ? (
				<img
					className='loading'
					src={LoadingGif}
					style={{
						display: 'block',
						margin: '0 auto',
						width: '68px',
						height: '68px'
					}}
					alt='Loading'
				/>
			) : (
				<div className='Expeditions'>
					{_.isEmpty(expeditions) ? (
						<p className='Expeditions__emptyMessage'>
							Currently there is no expeditions available...
						</p>
					) : (
						expeditions.map(expedition => {
							return (
								<button
									className='Expeditions__card Card'
									key={expedition.id}
									onClick={() => {
										setShowAssignModal({ show: true, expedition: expedition })
									}}>
									<div className='Card__description'>
										<h2 className='Card__description--name'>
											{expedition.expedition_name}
										</h2>
										<p className='Card__description--content'>
											{expedition?.expedition_description}
										</p>
									</div>
								</button>
							)
						})
					)}
				</div>
			)}
			{showAssignModal.show && (
				<ExpeditionsAssignmentModal
					expedition={showAssignModal.expedition}
					isDelete={false}
					handleClose={handleClose}
				/>
			)}
		</ImageHeader>
	)
}

export default Expeditions
